import { useLoader } from "@react-three/fiber";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { Group, Object3D, Object3DEventMap } from "three";
import { Context, createContext, useContext, useEffect, useState } from "react";

type DebugContextType = {
  debug: boolean;
};

const DebugContext: Context<DebugContextType> = createContext<DebugContextType>(
  { debug: false },
);

export const useDebug = (): DebugContextType => useContext(DebugContext);

export const DebugProvider = ({ children }: { children: React.ReactNode }) => {
  // Checks if url contains #debug
  const debug = window.location.hash === "#debug";

  return (
    <DebugContext.Provider value={{ debug }}>{children}</DebugContext.Provider>
  );
};
